class WhatsappChat extends HTMLElement {
  constructor() {
    super();
    this.launcher = this.querySelector('[data-whatsapp-chat-launcher]');
    this.panel = this.querySelector('[data-whatsapp-chat-panel]');
    this.closeButton = this.querySelector('[data-whatsapp-chat-close]');
    this.form = this.querySelector('[data-whatsapp-chat-form]');
    this.input = this.querySelector('[data-whatsapp-chat-input]');
    this.prompts = this.querySelectorAll('[data-whatsapp-chat-prompt]');

    this.phone = this.dataset.phone;

    this.launcher.addEventListener('click', this.onToggle.bind(this));
    this.closeButton.addEventListener('click', this.onClose.bind(this));
    this.form.addEventListener('submit', this.onSubmit.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));

    this.prompts.forEach((button) => {
      button.addEventListener('click', () => {
        this.openWhatsapp(button.textContent.trim());
      });
    });
  }

  onToggle() {
    if (this.panel.hidden) {
      this.open();
    } else {
      this.close();
    }
  }

  open() {
    this.panel.hidden = false;
    this.launcher.setAttribute('aria-expanded', 'true');
    this.classList.add('whatsapp-chat--open');
    window.trapFocus(this.panel, this.input);
  }

  close() {
    this.panel.hidden = true;
    this.launcher.setAttribute('aria-expanded', 'false');
    this.classList.remove('whatsapp-chat--open');
    window.removeTrapFocus(this.launcher);
  }

  onClose(event) {
    event.preventDefault();
    this.close();
  }

  onKeydown(event) {
    if (event.code === 'Escape' && !this.panel.hidden) {
      this.close();
    }
  }

  onSubmit(event) {
    event.preventDefault();
    const text = this.input.value.trim();
    if (!text) return;
    this.openWhatsapp(text);
    this.input.value = '';
  }

  openWhatsapp(text) {
    const url = `https://wa.me/${this.phone}?text=${encodeURIComponent(text)}`;
    window.open(url, '_blank', 'noopener');
  }
}

customElements.define('whatsapp-chat', WhatsappChat);
